import { render } from "./AssistantPage.vue?vue&type=template&id=48cdd202&scoped=true"
import script from "./AssistantPage.vue?vue&type=script&lang=js"
export * from "./AssistantPage.vue?vue&type=script&lang=js"

import "./AssistantPage.vue?vue&type=style&index=0&id=48cdd202&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48cdd202"]])

export default __exports__